<template>
  <div>
    <QuickFixDialogBase
      v-model="inputedValue"
      :title="title"
      :width="width"
      :pageData="pageData"
      isCardColor="true"
      @register="register"
    >
      <template v-slot:[pageData[0].name]>
        <div class="px-7">
          <v-container fluid>
            <v-row no-gutters class="pa-1">
              <v-col cols="6">
                <InputFormNew
                  :heading="$t('storage.storage_storage-move-info')"
                  v-model="pageInfoData.line1"
                  :detail="pageInfoDetail.line1"
                  :titleCols="inputFormStyle.titleCols"
                  :contentsCols="inputFormStyle.contentsCols"
                >
                </InputFormNew>
              </v-col>
              <v-col cols="6">
                <InputFormNew
                  :heading="$t('storage.storage_storage-move-info')"
                  v-model="pageInfoData.line2"
                  :detail="pageInfoDetail.line2"
                  :titleCols="inputFormStyle.titleCols"
                  :contentsCols="inputFormStyle.contentsCols"
                >
                  <template #postalCode>
                    <!-- 郵便番号 -->
                    <PostalCodeArea
                      v-model="pageInfoData.line2.postalCode"
                      :height="inputFormStyle.inputItemHeight"
                      :countryId="pageInfoData.line2.country.value"
                      @click="getAddressFromPostalCode"
                    />
                  </template>
                </InputFormNew>
              </v-col>
            </v-row>
          </v-container>
        </div>
      </template>
    </QuickFixDialogBase>
  </div>
</template>
<script>
import QuickFixDialogBase from './QuickFixDialogBase'

import headers from '@/views/order/Loading/headers'
// import InputFormNew from '@/components/items/Designs/InputFormNew'
import { mapActions } from 'vuex'
import {
  commonUtil,
  countryCallingCodeUtil,
  countryUtil,
  stockMoveUtil
} from '@/util'
import { InputFormNew, PostalCodeArea } from '@/components/items'

export default {
  components: {
    QuickFixDialogBase,
    InputFormNew,
    PostalCodeArea
  },
  props: {
    value: { default: false },
    width: { default: '540px' },
    title: { default: '' },
    recItems: {
      type: Object,
      require: true,
      default: () => ({})
    }
  },
  data: () => ({
    pageData: [],
    pageInfoData: {},

    // Design
    inputFormStyle: {
      rowHeight: '40px',
      titleCols: 3,
      contentsCols: 12 - 3,
      inputItemHeight: '32px'
    },
    pageInfoDetail: {
      line1: [
        {
          name: 'controlNumber',
          text: 'storage.storage_storage-move-adjust-number',
          component: 'text'
        },
        {
          name: 'shipStorageName',
          text: 'ship.ship_ship-storage',
          component: 'text'
        },
        {
          name: 'loadingStorageName',
          text: 'loading.loading_loading-storage',
          component: 'text'
        },
        {
          name: 'registerDate',
          text: 'storage.storage_register-date',
          component: 'text'
        },
        {
          name: 'trackingNumber',
          text: 'ship.ship_tracking-number',
          cols: 8
        },
        {
          name: 'storageMoveReasonId',
          text: 'storage.storage_storage-move-reason',
          required: true,
          component: 'SelectStockMoveReason',
          cols: 8
        }
      ],
      line2: [
        {
          name: 'fullName',
          text: 'common.input_name'
        },
        {
          name: 'phone',
          text: 'common.input_phone-number',
          component: 'PhoneNumberInput'
        },
        {
          name: 'country',
          text: 'common.input_country',
          cols: Math.ceil((12 - 3) / 2),
          component: 'SelectCountry'
        },
        {
          name: 'postalCode',
          text: 'common.input_postal-code',
          cols: Math.ceil((12 - 3) / 2)
        },
        {
          name: 'region',
          text: 'common.input_region',
          cols: Math.ceil((12 - 3) / 2),
          component: 'SelectRegion'
        },
        {
          name: 'address1',
          text: 'common.input_address_1'
        },
        {
          name: 'address2',
          text: 'common.input_address_2'
        }
      ]
    }
  }),
  created() {
    this.ini()
  },
  methods: {
    ...mapActions('StockMove', ['editStockMove']),
    ...mapActions('Common', ['setIsLoading']),
    ini() {
      const statusName = stockMoveUtil.getStockMoveStatusName(
        this.recItems.status
      )
      this.pageData = [
        {
          title: 'storage.storage_storage-move-info',
          name: 'stockMoveInfo',
          items: [],
          itemKey: ''
        },
        {
          title: `${this.$t('storage.storage_storage-move-detail')}（${
            this.recItems.shipStorage.name
          } → ${this.recItems.loadingStorage.name}）${statusName}`,
          name: 'stockMoveDetail',
          productHeaders: [
            {
              text: 'product.product_product-number',
              value: 'product.productNumber',
              sortable: false,
              width: '8%',
              class: 'rgba(151, 198, 234, 0.1)',
              align: 'center'
            },
            {
              text: 'common.product_product-name',
              value: 'productName',
              sortable: false,
              width: '30%',
              class: 'rgba(151, 198, 234, 0.1)'
            },
            {
              text: 'product.product_supplier',
              value: 'product.supplierId',
              sortable: false,
              width: '12%',
              class: 'rgba(151, 198, 234, 0.1)',
              align: 'center'
            },
            {
              text: 'common.product_capacity',
              value: 'product.capacity',
              sortable: false,
              width: '7%',
              class: 'rgba(151, 198, 234, 0.1)',
              align: 'center'
            },
            {
              text: 'storage.storage_storage-move-quantity',
              value: 'quantity',
              sortable: false,
              width: '7%',
              class: 'rgba(151, 198, 234, 0.1)',
              align: 'center'
            }
          ],
          itemKey: this.recItems.stockMoveId,
          items: this.recItems.productMoves
        }
      ]

      // console.log(items)

      this.pageInfoData = {
        line1: {
          controlNumber: this.recItems.transaction.controlNumber,
          shipStorageName: this.recItems.shipStorage.name,
          loadingStorageName: this.recItems.loadingStorage.name,
          registerDate: this.recItems.storageMoveDate,
          trackingNumber: this.recItems.trackingNumber,
          storageMoveReasonId: {
            value: this.recItems.storageMoveReasonId
          }
        },
        line2: {
          fullName: this.recItems.destName,
          // companyName: "",
          phone: {
            // TODO：APIのレスポンスはcodeで良いか
            countryCode: countryCallingCodeUtil.getPhoneNumberInfoById(
              this.recItems.destPhoneNumberCountryId
            ),
            phoneNumber: this.recItems.destPhoneNumber
          },
          country: countryUtil.getCountryIdInfo(this.recItems.destCountryId),
          postalCode: this.recItems.destPostalCode,
          // TODO：入力欄を動的にする
          region: countryUtil.getRegionInfo(
            this.recItems.destCountryId,
            this.recItems.destRegionId
          ),
          address1: this.recItems.destAddress1,
          address2: this.recItems.destAddress2
        }
      }
    },
    getAddressFromPostalCode(...args) {
      const [address] = args

      this.pageInfoData.line2.region = countryUtil.getRegionInfoByName(
        this.pageInfoData.line2.country.value,
        address.region
      )
      this.pageInfoData.line2.address1 = address.locality
      this.pageInfoData.line2.address2 = address.street
    },
    getInputValue() {
      return {
        stockMoveId: this.recItems.storageMoveId,
        trackingNumber: commonUtil.nullEmptyFormatNull(
          this.pageInfoData.line1.trackingNumber
        ),
        // storageMoveReasonId: this.pageInfoData.line1.storageMoveReasonId.value,
        shipDestName: commonUtil.nullEmptyFormatNull(
          this.pageInfoData.line2.fullName
        ),
        shipDestCountryId: commonUtil.nullEmptyFormatNull(
          this.pageInfoData.line2.country.value
        ),
        shipDestPostalCode: commonUtil.nullEmptyFormatNull(
          this.pageInfoData.line2.postalCode
        ),
        shipDestRegionId: commonUtil.nullEmptyFormatNull(
          commonUtil.formatRegion(this.pageInfoData.line2.region, true)
        ),
        shipDestRegion: commonUtil.nullEmptyFormatNull(
          commonUtil.formatRegion(this.pageInfoData.line2.region, false)
        ),
        shipDestAddress1: commonUtil.nullEmptyFormatNull(
          this.pageInfoData.line2.address1
        ),
        shipDestAddress2: commonUtil.nullEmptyFormatNull(
          this.pageInfoData.line2.address2
        ),
        shipDestPhoneNumberCountryId: commonUtil.nullEmptyFormatNull(
          this.pageInfoData.line2.phone.countryCode.value
        ),
        shipDestPhoneNumber: commonUtil.nullEmptyFormatNull(
          this.pageInfoData.line2.phone.phoneNumber
        )
      }
    },
    async register() {
      this.setIsLoading(true)
      const isConfirmed = confirm(this.$t('common.common_save-question'))
      if (!isConfirmed) {
        this.setIsLoading(false)
        return
      }
      const inputValue = this.getInputValue()
      const isSucceed = await this.editStockMove(inputValue)
      if (isSucceed) {
        this.inputedValue.dialog = false
        this.$emit('dialogReload')
      }
      this.setIsLoading(false)
    }
  },
  computed: {
    inputedValue: {
      get() {
        return this.value
      },
      set(newValue) {
        this.$emit('input', newValue)
      }
    }
  }
}
</script>
<style lang="scss" scoped></style>
